// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_TITLE_USERS_MANUAL_PHONE_VERIFICATION = "Over moje telef\u00f3nne \u010d\u00edslo";
